/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useCallback  } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// utils
// material
import { Button, displayModal, ToolTip } from '@insticator/insticator-ui';
import { ReactComponent as UpgradeIcon } from 'assets/icons/upgrade.svg'
import { ReactComponent as ProcessingIcon } from 'assets/icons/processing.svg'
// content
import MigrationModal from '../migrationmodal/migrationmodal';
// styles
import injectSheet from "react-jss";
import styles from './startmigration_styles';
import { DATA_MIGRATION_STARTED } from 'utils/consts/migration';

/* ========== ~~~~~~~~~~ MIGRATION STATUS WIDGET : START MIGRATION ~~~~~~~~~~ ========== */
const StartMigration  = injectSheet(styles)((props) => {
  const dispatch = useDispatch();
  const { canStartMigration } = useSelector(state => state.migrationStatus.migration)

  const activateMigration = () => {
    dispatch(displayModal(true, <MigrationModal migrationStatus={DATA_MIGRATION_STARTED} />))
  }

  return (
    <div className={`startmigration ${props.classes.startmigration} canstartmigration-${canStartMigration}`}>
      <div className='info'>
        <span className='icon'><UpgradeIcon height={30} width={30} /></span>
        <p className='text'>Site Upgraded to Commenting 2.0</p>
      </div>
      <div className='actions'>
        { !!canStartMigration ? 
            <Button text={'Start Data Migration'} handleClick={activateMigration} />
            :
            <div className='migrationongoing'>
              <Button text={'Start Data Migration'} disabled />
              <p className='processingmessage'>Another site data migration is ongoing. Please check again later.</p>
            </div>
        }
      </div>
    </div>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default StartMigration